import React, { useState } from "react";
import PropTypes from "prop-types";
import textFieldstyles from "../TextField/TextField.module.scss";
import styles from "./Password.module.scss";
import Label from "../Label/Label";
import ErrorMessage from "../Form/ErrorMessage";
import clsx from "clsx";
import { EyeOffIcon } from "../../icons/EyeOffIcon";
import { EyeIcon } from "../../icons/EyeIcon";

const Password = ({
  disabled = false,
  errors = {},
  label,
  colorLabel,
  name = "",
  placeholder,
  required = false,
  onChange,
  minLength,
  dataTestId,
  errorMessages,
}) => {
  const [peekPassword, setPeekPassword] = useState(false);

  const handlePeekPassword = (event, state) => {
    event.preventDefault();
    event.stopPropagation();
    setPeekPassword(state);
  };

  const IS_ERROR = !!errors[name];

  const PasswordIcon = peekPassword ? EyeOffIcon : EyeIcon;

  const formGroupClasses = clsx("input-group", {
    [textFieldstyles.inputGroupDisabled]: disabled,
    [textFieldstyles.inputGroup]: !disabled,
    [textFieldstyles.invalid]: IS_ERROR,
    [textFieldstyles.primary]: !disabled && !IS_ERROR,
  });

  return (
    <div className={clsx(styles.password, textFieldstyles.textField)} data-testid="Password">
      <Label disabled={disabled} color={colorLabel} htmlFor={name} required={required}>
        {label}
      </Label>

      <div className={formGroupClasses}>
        <input
          type={peekPassword ? "text" : "password"}
          onChange={onChange}
          className={clsx("form-control", styles.passwordField)}
          id={name}
          name={name}
          required={required}
          placeholder={placeholder}
          autoComplete={name}
          disabled={disabled}
          data-testid={dataTestId}
          minLength={minLength}
        />
        <div className={clsx("input-group-append", textFieldstyles.inputGroupAppend)}>
          <span className={clsx("input-group-text", textFieldstyles.inputGroupText)}>
            <div
              className={clsx(styles.showPasswordIcon, textFieldstyles.image)}
              onMouseDown={(event) => handlePeekPassword(event, true)}
              onTouchStart={(event) => handlePeekPassword(event, true)}
              onMouseUp={(event) => handlePeekPassword(event, false)}
              onTouchEnd={(event) => handlePeekPassword(event, false)}
              data-testid="PeekPassword"
            >
              <PasswordIcon className={clsx(styles.showPasswordIcon, textFieldstyles.image)} />
            </div>
          </span>
        </div>
      </div>
      <ErrorMessage
        errorMessages={errorMessages}
        errors={errors}
        label={label}
        name={name}
        minLength={minLength}
      />
    </div>
  );
};

Password.propTypes = {
  disabled: PropTypes.bool,
  errors: PropTypes.shape({
    type: PropTypes.string,
    message: PropTypes.string,
  }),
  errorMessages: PropTypes.object,
  label: PropTypes.string,
  colorLabel: PropTypes.string,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  onChange: PropTypes.func,
  minLength: PropTypes.number,
};

Password.defaultProps = {
  disabled: false,
  errors: {},
  errorMessages: {},
  label: "",
  name: "",
  placeholder: "",
  required: false,
  minLength: 0,
};

export default Password;
